<script>
export default {
  name: "uploaded-image",
  inject: ["getCanvas"],
  computed: {
    isSecondPlacement() {
      return this.$store.getters['ugc/tempData/getPlacementViewOrder'] === 1;
    },
    bufferImage() {
      // returns a JSON representation of the canvas already
      // stored if it exists for the current component
      // const { tempData: { activeUGCComponent }, placements: { buffers } } = this.$store.state.ugc;
      const { placements: { buffers } } = this.$store.state.ugc;
      const { activeUGCComponent } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      return buffers[activeUGCComponent]
        && buffers[activeUGCComponent][0]
        && buffers[activeUGCComponent][0].objects
        && buffers[activeUGCComponent][0].objects[0];
    },
    uploadedSrc() {
      //  returns the stored buffer image (the JSON representation of the
      // fabricCanvas) URL if it exists or the URL of the uploaded image
      // const { tempData: { ugc_image } } = this.$store.state.ugc;
      const { ugc_image } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      return (this.bufferImage && this.bufferImage.src) || ugc_image;
    }
  },
  watch: {
    uploadedSrc(newImg) {
      if (newImg) {
        this.setUploadedImage();
      }
    }
  },
  methods: {
    /**
     * Set the uploaded image into the canvas. It's invoked each time the URL
     * for the image in the editor changes.
     * @public
     */
    setUploadedImage() {
      // for the second placement the content of the canvas is kept,
      // so there's no need to set the canvas image
      if (this.isSecondPlacement) {
        this.$emit("image-loaded", true);
        return;
      }

      // sets the new URL when the image to be used in the canvas changes
      this
        .getCanvas()
        .then(fabricCanvas => {
          // if there are applied adjustments, don't change the image in the canvas
          if (this.$store.state.ugc.stateManager.steps < 2) {
            // updates the URL - the action is responsible for updating the canvas
            return this.$store.dispatch("ugc/SET_CANVAS_IMAGE", {
              fabricCanvas,
              imageSrc: this.uploadedSrc,
              isSecondPlacement: this.isSecondPlacement
            });
          }
        })
        .then(() => {
          this.$emit("image-loaded", true);
        })
        .catch(err => console.error("Error getting canvas image: ", err));
    }
  },
  created() {
    if (this.uploadedSrc) {
      this.setUploadedImage();
    }
  },
  render() {
    return null;
  }
};
</script>
